// permission.js
import Vue from 'vue'
import { hasPermission } from '@utils/permissionUtils';

export default function (el, binding) {
  if (!hasPermission(binding.value)) {
    Vue.nextTick(() => {
      el.parentNode && el.parentNode.removeChild(el)
    })
  }
}
